import { DATE_FORMATS } from "@/enums";
import { Button, DatePicker, Form, Modal } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { useIntl } from "react-intl";

interface IProps {
  scheduleId: string;
  handleChange: (date: dayjs.Dayjs | null) => void;
}

export const ReviewDatePicker = ({ scheduleId, handleChange }: IProps) => {
  const intl = useIntl();
  const [form] = Form.useForm();

  const [showModal, setShowModal] = useState(false);

  const handleOk = (): void => {
    const reviewDate = form.getFieldValue("reviewDate");

    setShowModal(false);
    form.resetFields();

    handleChange(reviewDate);
  };

  return (
    <>
      {!showModal && <Form form={form} component={false} />}
      <Button
        data-test-id={`schedule-${scheduleId}-custom-date-show-picker`}
        onClick={(): void => setShowModal(true)}
      >
        {intl.formatMessage({
          id: "projectMilestoneTable.customDateInput",
        })}
      </Button>
      <Modal
        title={intl.formatMessage({
          id: "projectMilestoneTable.selectReviewDate",
        })}
        open={showModal}
        onCancel={(): void => setShowModal(false)}
        onOk={handleOk}
      >
        <Form form={form}>
          <Form.Item name="reviewDate">
            <DatePicker
              format={DATE_FORMATS.fourDigitYear}
              placeholder={DATE_FORMATS.fourDigitYear}
              data-test-id={`schedule-${scheduleId}-history-date-picker`}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
